export default __webpack_public_path__ + "static/media/icon-contest.e9e28ab0.png";